export default "__VITE_ASSET__915c78cc__"